import React from 'react';
import Icon from './sports.svg';

const SportsIcon = ({className='', color='#a63d14'}) => {
	return <div className={'md:w-[26px] md:h-[30px] w-[21px] h-[24px]'}>
		<Icon color={color} aria-hidden={true} />
	</div>
};
export default SportsIcon;
